import { Auth0User } from "../types";

export const parseAuth0User = (auth0User?: Auth0User) => {
  if (!auth0User) {
    return {}; // Handle the case where user is undefined or null
  }
  try {
    const metadata = auth0User["https://mos-id.com/user_metadata"];
    const parsedUser: Auth0User = {
      sub: auth0User.sub || undefined,
      name: auth0User.name || undefined,
      email: auth0User.email || undefined,
      picture: auth0User.picture || undefined,
      superUser: metadata?.superUser || undefined,
      timeZone: metadata?.time_zone || undefined,
      organization: metadata?.organization || undefined,
      mapCenter: metadata?.map_center || undefined,
      hasConfirmedLicense: metadata?.map_center || undefined,
      addressSearchRadius: metadata?.address_search_radius || undefined,
    };
    return parsedUser;
  } catch (error) {
    console.error("Error parsing Auth0 user:", error); // Log the error for debugging
    return {}; // Return null if parsing fails
  }
};
